import { AiAddendumState } from "@shared/types/common";

const AI_APPROVED_STATES = new Set([
  AiAddendumState.AI_APPROVED,
  AiAddendumState.AI_APPROVED_PER_JPD,
  AiAddendumState.AI_APPROVED_BY_DEFAULT,
  AiAddendumState.AI_APPROVED_BY_DEFAULT_PER_JPD,
]);

const AI_PER_JPD_STATES = new Set([
  AiAddendumState.AI_APPROVED_PER_JPD,
  AiAddendumState.AI_APPROVED_BY_DEFAULT_PER_JPD,
]);

const AI_APPROVED_BY_DEFAULT_STATES = new Set([
  AiAddendumState.AI_APPROVED_BY_DEFAULT,
  AiAddendumState.AI_APPROVED_BY_DEFAULT_PER_JPD,
]);

const AI_DISABLED_STATES = new Set([
  AiAddendumState.AI_DISABLED,
  AiAddendumState.AI_DISABLED_BY_DEFAULT,
]);

export const isAiApproved = (state: AiAddendumState): boolean =>
  AI_APPROVED_STATES.has(state);

export const isAiApprovedPerJpd = (state: AiAddendumState): boolean =>
  AI_PER_JPD_STATES.has(state);

export const isAiApprovedByDefault = (state: AiAddendumState): boolean =>
  AI_APPROVED_BY_DEFAULT_STATES.has(state);

export const isAiDisabled = (state: AiAddendumState): boolean =>
  AI_DISABLED_STATES.has(state);

export const isAiAddendumApplicable = (
  state: AiAddendumState | undefined,
): boolean =>
  !!state &&
  state !== AiAddendumState.AI_NOT_APPLICABLE &&
  state !== AiAddendumState.AI_PERMANENTLY_REMOVED;
